
    export default {
      mounted() {
        this.highlightTarget = this.el.dataset.highlightTarget;
        this.fieldName = this.el.dataset.fieldName;
        this.matchIndex = 0;
        this.matchIndexLabel = this.el.querySelector('[data-role="match-index"]');

        if (this.matchIndexLabel) {
          this.totalMatches = parseInt(this.matchIndexLabel.dataset.totalMatches);
          this.matchIndexLabel.innerText = this.matchIndex + 1;
        }

        this.handleMouseEnter = () => {
          this.pushEventTo(this.highlightTarget, "highlight_field", {
            field_name: this.fieldName,
            highlight_index: this.matchIndex
          })
        }

        this.handlePrevClick = (event) => {
          event.preventDefault();
          this.prevIndex();
          this.pushEventTo(this.highlightTarget, "cycle_highlight", {
            highlight_index: this.matchIndex
          })
        }

        this.handleNextClick = (event) => {
          event.preventDefault();
          this.nextIndex();
          this.pushEventTo(this.highlightTarget, "cycle_highlight", {
            highlight_index: this.matchIndex
          })
        }

        this.prevTrigger = this.el.querySelector('[data-role="prev-trigger"]');
        this.nextTrigger = this.el.querySelector('[data-role="next-trigger"]');

        if (this.prevTrigger && this.nextTrigger) { this.bindPrevAndNextListeners() }

        this.el.addEventListener("mouseenter", this.handleMouseEnter)
      },

      updated() {
        this.matchIndexLabel = this.el.querySelector('[data-role="match-index"]');

        if (this.matchIndexLabel) {
          this.totalMatches = parseInt(this.matchIndexLabel.dataset.totalMatches);
          this.matchIndexLabel.innerText = this.matchIndex + 1;
        }

        this.prevTrigger = this.el.querySelector('[data-role="prev-trigger"]');
        this.nextTrigger = this.el.querySelector('[data-role="next-trigger"]');

        if (this.prevTrigger && this.nextTrigger) { this.bindPrevAndNextListeners() }
      },

      destroyed() {
        this.el.removeEventListener("mouseenter", this.handleMouseEnter)
        if (this.prevTrigger && this.nextTrigger) { this.removePrevAndNextListeners() }
      },

      nextIndex() {
        this.matchIndex = (this.matchIndex + 1) % this.totalMatches

        this.matchIndexLabel.innerText = this.matchIndex + 1;
      },

      prevIndex() {
        this.matchIndex = (this.matchIndex - 1 + this.totalMatches) % this.totalMatches

        this.matchIndexLabel.innerText = this.matchIndex + 1;
      },

      bindPrevAndNextListeners() {
        this.removePrevAndNextListeners();

        this.prevTrigger.addEventListener("click", this.handlePrevClick)
        this.nextTrigger.addEventListener("click", this.handleNextClick)
      },

      removePrevAndNextListeners() {
        this.prevTrigger.removeEventListener("click", this.handlePrevClick)
        this.nextTrigger.removeEventListener("click", this.handleNextClick)
      }
    }
  